import { Serializer } from 'miragejs';

export default Serializer.extend({});
